import { oz } from '@weft/utils';

export const OVERGAE_SETTINGS = Object.freeze({
  NoCharge: 'NoCharge',
  ChargeTier: 'ChargeTier',
  ChargeExtras: 'ChargeExtras',
}); 

export const OverageSettingsSchema = oz.nativeEnum(OVERGAE_SETTINGS).openapi('OverageSettings');

export type OverageSettings = oz.infer<typeof OverageSettingsSchema>;